import { useEffect, useMemo, useRef, useState } from "react";
import Slider from "react-slick";
import styled from "styled-components";
import { useModal } from "../utils/useModal";
import FadeInItem from "./FadeInItem";
import { BREAK_POINT } from "../constants";

const StillPhotos = () => {
  const { onModal } = useModal();
  const [positionX, setPositionX] = useState(0);

  const sliderSetting = {
    swipe: true,
    arrows: true,
    infinite: true,
    slidesToShow: 3,
    rows: 2,
    centerMode: true,
    centerPadding: "0",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          swipe: true,
          infinite: true,
          rows: 1,
          slidesToScroll: 1,
          slidesToShow: 1,
          slidesPerRow: 1,
          centerMode: true,
          centerPadding: "0",
        },
      },
    ],
  };

  const photoList = useMemo(
    () => [
      "still_1.jpg",
      "still_2.jpg",
      "still_3.jpg",
      "still_4.jpg",
      "still_5.jpg",
      "still_6.jpg",
      "still_7.jpg",
      "still_8.jpg",
      "still_9.jpg",
      "still_10.jpg",
      "still_11.jpg",
      "still_12.jpg",
    ],
    []
  );

  const handleMouseDown = (e: MouseEvent) => {
    setPositionX(e.clientX);
  };

  const handleClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    id: string
  ) => {
    if (positionX !== e.clientX) {
      e.stopPropagation();
      e.preventDefault();
    } else {
      onModal({
        type: "ImageModal",
        payload: {
          id,
        },
      });
    }
  };

  useEffect(() => {
    window.addEventListener("mousedown", handleMouseDown);

    return () => {
      window.removeEventListener("mousedown", handleMouseDown);
    };
  }, []);

  return (
    <Wrapper>
      <FadeInItem point={0.25}>
        <div>
          <Slider {...sliderSetting}>
            {photoList.map((photo, idx) => (
              <StillItem
                key={`${photo}_${idx}`}
                onClick={(e) => handleClick(e, photo)}
              >
                <img src={`/assets/${photo}`} alt="photos" />
              </StillItem>
            ))}
          </Slider>
          <Chu>
            <img src="/assets/cha_chu.png" alt="chu" />
          </Chu>
        </div>
      </FadeInItem>
    </Wrapper>
  );
};

export default StillPhotos;

const Wrapper = styled.div`
  padding: 162px 0 240px;
  display: flex;
  justify-content: center;

  > div {
    width: 74%;
    position: relative;
  }

  .slick-slider {
    z-index: 2;
  }

  .slick-prev {
    z-index: 2;
    &:before {
      content: "";
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .slick-next {
    &:before {
      content: "";
      position: absolute;
      top: 50%;
      transform: translate(50%, -50%);
    }
  }

  @media only screen and (min-width: ${BREAK_POINT.tablet}) {
    .slick-slide {
      > div {
        padding: 14px 14px;
      }
    }

    .slick-list {
      margin: 0 -30px;
    }

    .slick-prev {
      &:before {
        left: -44px;
        width: 70px;
        height: 70px;
        background: url("/assets/icon_left_arrow.png") no-repeat;
      }
    }

    .slick-next {
      &:before {
        right: -44px;
        width: 70px;
        height: 70px;
        background: url("/assets/icon_right_arrow.png") no-repeat;
      }
    }
  }

  @media only screen and (max-width: 1150px) {
    padding: calc(30% + 70px) 0 100px;

    .slick-prev {
      &:before {
        left: 0;
        width: 35px;
        height: 35px;
        background: url("/assets/icon_mobile_left_arrow.png") no-repeat;
      }
    }

    .slick-next {
      &:before {
        right: 0;
        width: 35px;
        height: 35px;
        background: url("/assets/icon_mobile_right_arrow.png") no-repeat;
      }
    }
  }

  @media only screen and (max-width: 600px) {
    padding: calc(30% + 70px) 0 14%;
  }
`;

const StillItem = styled.div`
  width: 100%;
  height: 100%;
  cursor: pointer;
`;

const Chu = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -80%);
  display: none;
  z-index: 1;

  img {
    width: 80%;
  }

  @media only screen and (max-width: ${BREAK_POINT.tablet}) {
    display: flex;
    justify-content: center;
  }
`;
